export const urlGenerator = (url, payload) => {
  const result = Object.keys(payload)
    .map(key => `${key}=${payload[key]}`)
    .join('&')
  return `${url}?${result}`
}
